import React from 'react';
import styles from "./TokenTableRow.module.scss";
import tableColStyles from "./TableColumns.module.scss";

export const TokenTableRowSkeleton: React.FC = () => (
  <div className={styles.row}>
    <div className={`${styles.cell} ${tableColStyles.tableCol} ${tableColStyles.tableColToken}`}>
      <div className={`${styles.skeleton} ${styles.tokenIcon}`}></div>
      <div className={`${styles.skeleton} ${styles.tokenName}`}></div>
    </div>
    <div className={`${styles.cell} ${tableColStyles.tableCol} ${tableColStyles.tableColPrice}`}>
      <div className={`${styles.skeleton} ${styles.price}`}></div>
    </div>
    <div className={`${styles.cell} ${tableColStyles.tableCol} ${tableColStyles.tableColMarketCap}`}>
      <div className={`${styles.skeleton} ${styles.marketCap}`}></div>
    </div>
    <div className={`${styles.cell} ${tableColStyles.tableCol} ${tableColStyles.tableColLiquidity}`}>
      <div className={`${styles.skeleton} ${styles.liquidity}`}></div>
    </div>
    <div className={`${styles.cell} ${tableColStyles.tableCol} ${tableColStyles.tableColVolume}`}>
      <div className={`${styles.skeleton} ${styles.volume}`}></div>
    </div>
    <div className={`${styles.cell} ${tableColStyles.tableCol} ${tableColStyles.tableColBuy}`}>
      <div className={`${styles.skeleton} ${styles.buyButton}`}></div>
    </div>
  </div>
);
